import * as React from "react";
import styled, { DefaultTheme } from "styled-components";

const SeparatorEl = styled.span<Required<ISeparatorProps>>`
  background-color: ${(p) => p.theme.colors.borders.light};
  display: block;
  height: 1px;
  margin: ${(p) => p.theme.layout.margin[p.margin]}px 0;
`;

interface ISeparatorProps extends React.HTMLProps<HTMLElement> {
  margin?: keyof DefaultTheme["layout"]["margin"];
}

export const Separator = ({ margin = "m", ...other }: ISeparatorProps) => {
  return <SeparatorEl {...(other as any)} margin={margin} />;
};
